{
  "api": {
    "locationValidationTitle": "हम आपके स्थान को सत्यापित नहीं कर सके",
    "thresholdTitle": "चेक-इन के लिए समय पर नहीं",
    "warehouseUnavailableTitle": "वेयरहाउस उपलब्ध नहीं",
    "warehouseUnavailableMessage": "मैन्युअल चेक-इन के लिए कृपया सुविधा कर्मचारियों से संपर्क करें",
    "characterLimitTitle": "इनपुट अक्षर सीमा से अधिक है",
    "genericTitle": "चेक-इन विफल रहा। कृपया, पुनः प्रयास करें।",
    "recaptchaTitle": "सत्यापन विफल रहा",
    "recaptchaMessage": "हम आपके अनुरोध का सत्यापन नहीं कर सके। कृपया पुनः प्रयास करें या सुविधा कर्मचारियों से संपर्क करें।"
  }
}
